export default function (options) {
  let defaultOptions = {
    autoWidth: false,
    responsive: true,
    paging: false,
    ordering: true,
    search: {
      caseInsensitive: true
    },
    scrollY: "70vh",
    dom: 'Bfrtip',
    buttons: [
      'csv', 'excel'
    ],
    lengthMenu: [[15, 30, 45, -1], ["15 lignes", "30 lignes", "45 lignes", "Tout"]],
    language: {searchPlaceholder: "Recherche..."},
    initComplete: function (a, b) {
      $(this).closest(".dataTables_wrapper").prepend('<div class="dataTables_buttons">' +
        '<div class="dropup actions__item">' +
        '<i data-toggle="dropdown" class="fa fa-download">' +
        '</i>' +
        '<ul class="dropdown-menu">' +
        '<li><a href="" class="dropdown-item" data-table-action="excel">Excel (.xlsx)</a></li>' +
        '<li><a href="" class="dropdown-item" data-table-action="csv">CSV (.csv)</a></li>' +
        '</ul>' +
        '</div>' +
        '</div>')
    }
  }
  options = Object.assign({}, defaultOptions, options)

  $('.app-table').each((index, $element) => {
    let ajaxOption = $element.getAttribute('data-table-ajax')
    if (ajaxOption) {
      let apiToken = document.querySelector('meta[name=\'api-token\']').content
      options['ajax'] = {
        url: ajaxOption,
        type: 'POST',
        headers: {
          Authorization: 'Bearer ' + apiToken
        }
      }
      options['processing'] = true
      options['serverSide'] = true
    }
    $($element).dataTable(options)
    $("body").on("click", "[data-table-action]", function (a) {
      a.preventDefault();
      let b = $(this).data("table-action");
      if ("excel" === b && $(this).closest(".dataTables_wrapper").find(".buttons-excel").trigger("click"), "csv" === b && $(this).closest(".dataTables_wrapper").find(".buttons-csv").trigger("click"), "print" === b && $(this).closest(".dataTables_wrapper").find(".buttons-print").trigger("click"), "fullscreen" === b) {
        let c = $(this).closest(".card");
        c.hasClass("card--fullscreen") ? (c.removeClass("card--fullscreen"), $("body").removeClass("data-table-toggled")) : (c.addClass("card--fullscreen"), $("body").addClass("data-table-toggled"))
      }
    })
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/module/app.data-table.js